import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomDropdown from "../../../../Core/Components/CustomDropdown";
import ChevronIcon from "../../../../Common/Svgs/ChevronIcon";
import {
  updateItemById,
  updateTrips,
} from "../../../../Redux/Slices/trips.slice";
import useOriginStops from "../useOriginStops";
import { getLocationStops } from "../useLocationStops";

const LocationSelector = ({
  data,
  totalLength,
  open,
  setOpen,
  setActivityDropdown,
}) => {
  const dispatch = useDispatch();

  const { allLocations } = useSelector((state) => state.locations);

  const { stops, validationForSteps, toastMessage, tripDetails } = useSelector(
    (state) => state.trips,
  );

  // origin and destination based on hubIds of the user
  const origins = useOriginStops();

  // dropdown border color
  const renderBorderColorForLocation = () => {
    if (open) return "border border-primary";

    if (validationForSteps.step1.location && data.location === "Stop")
      return "border border-alert-red";

    return "border border-light-grey";
  };

  const handleLocationSelection = (e, id) => {
    const newLocation = {
      locationId: e.key,
      location: e.value,
    };

    // for origin and destination
    if (id === 1 || id === totalLength) {
      if (id === 1 && String(stops[0]?.locationId) !== String(e.key)) {
        dispatch(
          updateTrips({
            key: "tripDetails",
            value: {
              ...tripDetails,
              batteries: [],
            },
          }),
        );
      }

      dispatch(
        updateItemById({
          arrayKey: "stops",
          itemId: id,
          updatedData: newLocation,
        }),
      );

      dispatch(
        updateTrips({
          key: "validationForSteps",
          value: {
            ...validationForSteps,
            step1: { ...validationForSteps.step1, location: false },
          },
        }),
      );

      setActivityDropdown(false);
    }
    // for intermidiate stops
    else {
      const exists = stops.find((st) => st.location === e.value);

      // stop exists
      if (exists) {
        dispatch(
          updateTrips({
            key: "toastMessage",
            value: {
              ...toastMessage,
              visible: true,
              type: "sameStop",
              id: exists.id,
            },
          }),
        );

        setActivityDropdown(false);
      }
      // stop does not exists
      else {
        dispatch(
          updateItemById({
            arrayKey: "stops",
            itemId: id,
            updatedData: newLocation,
          }),
        );

        dispatch(
          updateTrips({
            key: "validationForSteps",
            value: {
              ...validationForSteps,
              step1: { ...validationForSteps.step1, location: false },
            },
          }),
        );

        setActivityDropdown(true);
      }
    }
  };

  return (
    <CustomDropdown
      trigger={["click"]}
      customHeight="max-h-[200px]"
      items={
        data.id === 1 || data.id === totalLength
          ? origins
          : getLocationStops({ stops, allLocations, id: data.id })
      }
      dropDownOpen={open}
      onOpenChange={(flag) => setOpen(flag)}
      handleClick={(e) => {
        handleLocationSelection(e, data.id);
      }}
      enableSearch
      searchPlaceholder="Search Location"
    >
      <div
        className={`w-full rounded-md py-2 px-3.5 flex items-center justify-between cursor-pointer ${renderBorderColorForLocation()} `}
      >
        <p className="text-xs font-semibold text-black capitalize font-aileron">
          {data.location === "Stop" ? "Select Location" : data.location}
        </p>

        <ChevronIcon
          className={`w-5 h-5 rotate-90 stroke-dark-gray transform transition-all duration-200 ${
            open ? "-rotate-90" : "rotate-90"
          }`}
        />
      </div>
    </CustomDropdown>
  );
};

export default LocationSelector;
